module.exports = __webpack_public_path__ + "static/media/42_B.ad53e647.png";